module.exports = __webpack_public_path__ + "static/media/minted.0b970bca.png";